module.exports = __webpack_public_path__ + "static/media/flag-us.3d4b4e13.svg";